interface ExceptionInfo {
    error: unknown;
    context: string;
}
interface Response {
    isSuccess: boolean;
    exceptionInfo?: ExceptionInfo;
}

export async function copyLinkToClipboard(link: string): Promise<Response> {
    try {
        await navigator.clipboard.writeText(link);
        const response: Response = {
            isSuccess: true,
        };
        return response;
    } catch (error) {
        const response: Response = {
            isSuccess: false,
            exceptionInfo: {
                context: 'shareLinkHelper.copyLinkToClipboard',
                error,
            },
        };
        return response;
    }
}
